import React from "react";
import {
    DeviceThermostatOutlined,
    SpeedOutlined,
    EarthquakeOutlined,
    SensorsOutlined,
    BoltOutlined
} from "@mui-symbols-material/w200";

export const telemetryIconFactory = (unitSymbol?: string, size?: number): React.ReactNode => {
    const iconSize = size || 48;
    const sx = { fontSize: `${iconSize}px` };

    if (!unitSymbol) {
        return <SensorsOutlined sx={sx} />;
    }

    // Normalize the unit symbol for comparison
    const normalizedSymbol = unitSymbol.toLowerCase();

    // Temperature units
    if (normalizedSymbol === '°c' || normalizedSymbol === '°f' || normalizedSymbol === 'k' ||
        normalizedSymbol.includes('celsius') || normalizedSymbol.includes('fahrenheit') || normalizedSymbol.includes('kelvin')) {
        return <DeviceThermostatOutlined sx={sx} />;
    }

    // Pressure units
    if (normalizedSymbol === 'hpa' || normalizedSymbol === 'pa' || normalizedSymbol === 'bar' ||
        normalizedSymbol === 'psi' || normalizedSymbol.includes('pascal') || normalizedSymbol.includes('pressure')) {
        return <SpeedOutlined sx={sx} />;
    }

    // Vibration units
    if (normalizedSymbol === 'mg' || normalizedSymbol === 'g' ||
        normalizedSymbol.includes('vibration') || normalizedSymbol.includes('acceleration')) {
        return <EarthquakeOutlined sx={sx} />;
    }

    // Energy/Power units
    if (normalizedSymbol === 'w' || normalizedSymbol === 'kw' || normalizedSymbol === 'mw' ||
        normalizedSymbol === 'kwh' || normalizedSymbol === 'wh' || normalizedSymbol === 'mwh' ||
        normalizedSymbol.includes('watt') || normalizedSymbol.includes('energy') ||
        normalizedSymbol.includes('power') || normalizedSymbol.includes('consumption')) {
        return <BoltOutlined sx={sx} />;
    }

    // Default fallback
    return <SensorsOutlined sx={sx} />;
};
